import { DateTime } from "luxon";
import { DateRange } from "react-day-picker";

type DateInput = DateRange | { startDate: string; endDate: string } | undefined;

export const PARAMETER_DATE_FORMAT_ISO = "yyyy-MM-dd'T'HH:mm:ss";

export const formatDateRange = (
  range: DateInput,
  format: string = PARAMETER_DATE_FORMAT_ISO,
) => {
  if (range && "from" in range && range.from && range.to) {
    return {
      startDate: DateTime.fromJSDate(range.from)
        .startOf("day")
        .toFormat(format),
      endDate: DateTime.fromJSDate(range.to).endOf("day").toFormat(format),
    };
  }

  return undefined;
};

// default range of 7 days
export const getDefaultDateRange = (timezone: string, daysBack = 6) => {
  const today = DateTime.now().setZone(timezone).startOf("day");
  return {
    startDate: today.minus({ days: daysBack }).startOf("day").toISODate(),

    endDate: today.endOf("day").toISODate(),
  };
};
